import initRemoteSdk from '@platform-sdk/platform-sdk/remote';
import initRemoteReactSdk from '@platform-sdk/platform-sdk/remote/react';

const remoteSdk = initRemoteSdk('caduceus-remote-sdk');
export default remoteSdk;

// React Extension
const { theme } = initRemoteReactSdk(remoteSdk);
export const { useResolvedTheme } = theme;
